import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export const RegisterButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      className="bg-primary font-bold text-white px-4 py-2 rounded-full text-sm"
      onClick={() => navigate("/register")}
    >
      新規登録
    </Button>
  );
};
